<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/craft/debug/log/page"
                   getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('caozuoshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.createTimeStart"
                           :end.sync="yt.conditions.createTimeEnd">
            </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentIds">
            </yi_data_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary"
                       plain="plain">
              {{$t('sousuo')}}
            </el-button>
            <el-button @click="yt.clear({createTimeStart: begin(),createTimeEnd:end(),orderBy:'createTime desc'})">{{$t('chongzhi')}}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')"
                   @click="exportRecord()"></el-button>
      </template>
      <template #gongyicanshu="scope">
        <span v-if="($t(store.state.eqPoints[scope.row.equipmentId][scope.row.parameter].unit))=== undefined">
          {{$t(store.state.eqPoints[scope.row.equipmentId][scope.row.parameter].alias)}}
        </span>
        <span v-else>
           {{$t(store.state.eqPoints[scope.row.equipmentId][scope.row.parameter].alias)}}
           {{'('}}
           {{$t(store.state.eqPoints[scope.row.equipmentId][scope.row.parameter].unit)}}
           {{')'}}
        </span>

      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_process_management_adjustment_record_list',
  data() {
    return {
      exceptionTypeList: [],
      columns: [{
        label: 'shebeimingcheng',
        prop: 'equipment.name',
      }, {
        type: 'slot',
        label: 'gongyicanshu',
        prop: 'parameter',
        width: 180
      }, {
        label: 'xiugaiqian',
        prop: 'beforeChange',
        width: 180,
      }, {
        label: 'xiugaihou',
        prop: 'afterChange',
        width: 180,
      }, {
        label: 'caozuoshijian',
        prop: 'createTime',
        type: 'time',
        width: 180,
        // format: 'yyyy-MM-dd:hh:mm:ss'
      },
        {
          label: 'caozuoren',
          prop: 'createByObject.nickname',
          width: 130,
        },

      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: 'createTime desc',
      }
      this.$set(this.yt.conditions, 'createTimeStart', this.begin())
      this.$set(this.yt.conditions, 'createTimeEnd', this.end())
      this.yt.get(1);
    }, 300)
  },
  methods: {
    //导出
    exportRecord() {
      let params = this.yt.conditions
      return this.http.get('/web/report/export/gongyiguanli_tiaojijilu', {
        params
      }).then(res => {
        this.$message.success(this.$t(res.msg))
        this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG')
      }).catch(error => {
        this.$message.error(this.$t(error))
      })
    },
    begin() {
      const date = new Date()
      const begin = (new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0)).getTime()
      return begin
    },
    end() {
      const date = new Date()
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const lastDay = new Date(year, month, 0).getDate();
      const end = (new Date(year, month - 1, lastDay, 23, 59, 59)).getTime()
      return end
    },
  }
};
</script>
